import { characterUpdateCommand } from './character_update';

export const characterCommands = [
  characterUpdateCommand
];

export { characterUpdateCommand };



